import { roles } from '@/constants';

export const ACCESS_STATES = Object.freeze({
    ANONYMOUS: 'anonymous',
    BLOCKED: 'blocked',
    ONBOARDING: 'onboarding',
    READY: 'ready',
});

/**
 * Resolve where a visitor stands relative to the app. Order matters: a fatal error or a student role
 * blocks access even when no mode was ever set (the educator error paths return before `updateMode`),
 * so those are checked before "no mode means no session".
 * @param {Object} options
 * @param {string} [options.mode] - Current app mode; empty until a session resolves
 * @param {*} [options.error] - Fatal app error, if any
 * @param {boolean} [options.onboarded] - The user finished onboarding (see `hasCompletedOnboarding`)
 * @returns {'anonymous'|'blocked'|'onboarding'|'ready'}
 */
export const resolveAccessState = ({ mode, error, onboarded }) => {
    if (error || mode === roles.STUDENT_ROLE) return ACCESS_STATES.BLOCKED;
    if (!mode) return ACCESS_STATES.ANONYMOUS;
    if (mode === roles.DE_ROLE) return ACCESS_STATES.READY;
    return onboarded ? ACCESS_STATES.READY : ACCESS_STATES.ONBOARDING;
};
